import React from 'react';
import { func, object } from 'prop-types';
import { Route, Redirect, Switch } from 'react-router-dom';
import { withRouter } from 'react-router';

import SignIn from './Authentication/SignIn';
import SignUp from './Authentication/SignUp';
import ForgotPassword from './Authentication/ForgotPassword';

const EsmsPublic = ({ location, signIn, ...props }) => (
    <Switch>
        <Route
            exact
            path="/signin"
            render={(routeProps) => (
                <SignIn {...routeProps} signIn={signIn} />
            )}
        />
        <Route path="/signup" exact component={SignUp} />
        <Route
            component={ForgotPassword}
            exact
            path="/forgotpassword"
        />
        <Route
            path="/"
            render={(routeProps) => (
                <Redirect
                    from="/"
                    to={{
                        pathname: '/signin',
                        state:    {
                            from: `${location.pathname}${location.search}`
                        }
                    }}
                />
            )}
        />
    </Switch>
);

EsmsPublic.propTypes = {
    location: object.isRequired,
    signIn:   func.isRequired
};


export default withRouter(EsmsPublic);
